/**
 * 导航栏
 * @author 蓝胖
 * @time 2018/6/25
 * 使用方法：
 * <NavBar
 *  title=""      //标题
 *  leftContent   //自定义左边内容，默认是 返回图标
 *  rightContent  //右边内容
 *  shadowStyle   //是否要navbar下边框 默认true
 *  showLeftContent //是否展示左边内容，默认true
 *  hidePlace // 是否隐藏占位元素，默认false
 * />
 */

import React, { Component } from 'react';
import { NavBar } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import './index.less';

/**
 * @deprecated 已废弃的组件，请使用HeaderBar
 */
@inject('AppMod')
@observer
class HeaderNav extends Component {
  constructor(props, context) {
    super(props, context);
    const { isApp } = this.props.AppMod;
    this.state = {
      isApp
    };
  }

  componentDidMount() {
    if (this.state.isApp) {
      let { children, title } = this.props;
      // 当传递过来的children是动态生成的时，会传递个数组过来，可参考购物车传递的children
      if (Array.isArray(children)) {
        children = children.join('');
      }
      setTimeout(() => {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'setTitle',
            data: title || children || '完美商城'
          })
        );
      }, 500);
    }
  }

  /**
   * 返回上一页函数
   */
  _onLeftClick = async () => {
    let resultDomain = await this.props.AppMod.getCheckHostDomain();
    if (!resultDomain) return;
    if (window.history && window.history.length === 1) {
      window.app.routerRedirect('/shop/home');
      return;
    }
    if (window.app.router.location.pathname == '/login' && this.props.AppMod.isOnMineTab) {
      window.app.routerRedirect('/shop/home');
      return;
    }
    if (window.app.router.location.pathname == '/personal/account') {
      // 在个人中心绑定Google后，需要指定返回路径，否则会返回到Google的页面
      window.app.routerRedirect('/personal');
      return;
    }

    this.props.callback && this.props.callback();
    window.app.router.goBack();
  };

  /**
   * 返回 < 按钮
   * @returns {*}
   */
  _renderBackBtn = () => {
    return <span className="iconfont icon-fanhui" />;
  };

  render() {
    const {
      id = '',
      leftContent,
      rightContent,
      onLeftClick,
      title = '',
      shadowStyle = true,
      showLeftContent = true,
      className = '',
      style = {},
      hidePlace = false,
      children = null,
      titleStyle = {},
      mode
    } = this.props;
    const rightBtn = rightContent || null;
    let leftBtn = null;
    if (showLeftContent) {
      leftBtn = leftContent || this._renderBackBtn();
    }
    if (this.state.isApp) {
      return null;
    }
    let titleView = null;
    if (children) {
      if (typeof children === 'string') {
        titleView = (
          <div className="title" style={titleStyle}>
            {children}
          </div>
        );
      } else if (typeof children === 'object' && children instanceof Array) {
        // 是否是数组（例如：购物车({count})，会以数组的形式传进来）
        titleView = (
          <div className="title" style={titleStyle}>
            {React.Children.map(children, (child) => {
              return typeof child === 'string' ? child : child.props.text;
            }).join('')}
          </div>
        );
      } else {
        titleView = children;
      }
    } else {
      titleView = (
        <div className="title" style={titleStyle}>
          {title}
        </div>
      );
    }

    return (
      <React.Fragment>
        <NavBar
          id={id}
          className={`navbar-widget ${shadowStyle ? 'nav-bar-shadow' : ''} ${className}`}
          leftContent={leftBtn}
          mode={mode || 'light'}
          onLeftClick={onLeftClick || this._onLeftClick}
          rightContent={rightBtn}
          style={style}>
          {titleView}
        </NavBar>
        {/* 占位元素 */}
        {hidePlace ? null : <div className="navbar-place" />}
      </React.Fragment>
    );
  }
}

module.exports = HeaderNav;



// WEBPACK FOOTER //
// ./src/widget/NavBar/index.js